import AuthProvider from "./AuthProvider";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import Routing from "./routing";
import './App.css';

function App() {

  return (

      <Router basename="/crm">
        <AuthProvider>
          <Routing/>
        </AuthProvider>
      </Router>
  );
}

export default App;
